import React, { Component } from 'react';
import Dashboard from './Dashboard'

class index extends Component {
    state={
        delay:30000
    }
    onUpdateDelay=(dealy)=>{
     //   console.log(dealy)
        this.setState({
            delay:dealy
        })
    }
    render() {
        let {Token}  = this.props.match.params;
        return (
            <>
               <Dashboard
               delay={this.state.delay}
               Token={Token}
               updateDelay={this.onUpdateDelay}
               /> 
            </>
        );
    }
}

export default (index);